import { Observable } from "rxjs";
import { Resolve } from "@angular/router";
import { Injectable } from "@angular/core";
declare const Razorpay: any;


@Injectable()
export class RazorpayResolverService implements Resolve<Observable<any>> {

  constructor() { }

  resolve(): Observable<any> {
    return new Observable((obs) => {
            try{
                console.log(Razorpay);
                obs.next(true);
                obs.complete();
            }catch(e){
                const script = document.createElement('script');
                script.onload = () => {
                    obs.next(true);
                    obs.complete();
                };
                script.onerror = (error) => {
                    obs.next(true);
                    obs.complete();
                };
                script.src = 'https://checkout.razorpay.com/v1/checkout.js';
                document.head.appendChild(script);
        }
        
    });
  }
}
